import React from 'react';
import { MBText } from '@shared/components/text';
import { Colors } from '@shared/styles';

interface MBSentBySMSProps {
  message: MBAPI.ChatMessage;
}

/*
    Simple text indicating that the message has been sent by SMS
*/
export function MBSentBySMS({ message }: MBSentBySMSProps) {
  if (!message.urgent && !message.sentBySMS) {
    return null;
  }
  return (
    <MBText color={Colors.gray.normal} style={{ paddingTop: 2, fontSize: 10 }}>
      Sent by SMS
    </MBText>
  );
}
